import React from 'react';
import { Book, Stethoscope, Utensils, Image as ImageIcon, Smartphone, Briefcase } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    icon: <Stethoscope className="w-8 h-8" data-id="element-213" />,
    title: 'TOMO 1 — CLÍNICA & ANAMNESIS',
    desc: 'Fichas de ingreso · Anamnesis por patología · R24h · Evaluación antropométrica · Protocolos de derivación'
  }, {
    icon: <Book className="w-8 h-8" data-id="element-214" />,
    title: 'TOMO 2 — PROTOCOLOS PATOLÓGICOS',
    desc: 'Guías de intervención para las 12 patologías más frecuentes del consultorio argentino. Diabetes · HTA · SOP · Celíaca · SII · Dislipemia · Hipotiroidismo · HGNA y más'
  }, {
    icon: <Utensils className="w-8 h-8" data-id="element-215" />,
    title: 'TOMO 3 — RECETARIO MAESTRO',
    desc: '120 recetas con macros calculados · Ingredientes 100% accesibles en Argentina · Listas para entregar hoy'
  }, {
    icon: <ImageIcon className="w-8 h-8" data-id="element-216" />,
    title: 'TOMO 4 — EDUCACIÓN VISUAL',
    desc: '21 láminas para imprimir o enviar por WhatsApp. Plato saludable · Semáforo · Porciones · Etiquetas'
  }, {
    icon: <Smartphone className="w-8 h-8" data-id="element-217" />,
    title: 'TOMO 5 — SOCIAL MEDIA 365 DÍAS',
    desc: '60 hooks · 30 guiones de Reels · 30 carruseles · 60 captions · 52 semanas de Stories · Calendario anual'
  }, {
    icon: <Briefcase className="w-8 h-8" data-id="element-218" />,
    title: 'TOMO 6 — BUSINESS & GESTIÓN',
    desc: 'Precios · Paquetes · Fidelización · Control financiero · Teleconsulta · Escalabilidad · Plantillas de WhatsApp'
  }];
  return <section className="bg-black text-white py-24 px-4" data-id="element-219">
      <div className="max-w-6xl mx-auto" data-id="element-220">
        <div className="text-center mb-16" data-id="element-221">
          <h2 className="font-display font-black text-5xl md:text-6xl mb-4 uppercase" data-id="element-222">
            PACK NUTRICIÓN PRO
          </h2>
          <p className="text-2xl text-brand font-bold uppercase tracking-widest" data-id="element-223">
            6 Tomos Completos
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-224">
          {tomos.map((tomo, i) => <div key={i} className="bg-zinc-900 border-t-4 border-brand rounded-b-xl p-8 hover:bg-zinc-800 transition-colors" data-id="element-225">
              <div className="w-16 h-16 bg-brand/10 text-brand rounded-xl flex items-center justify-center mb-6" data-id="element-226">
                {tomo.icon}
              </div>
              <h3 className="font-display font-bold text-xl mb-4 text-white" data-id="element-227">
                {tomo.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-228">{tomo.desc}</p>
            </div>)}
        </div>

        <div className="mt-16 bg-zinc-900 border border-zinc-800 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-229">
          <h4 className="font-display font-bold text-2xl mb-6 text-brand" data-id="element-230">
            CADA TOMO INCLUYE:
          </h4>
          <div className="grid sm:grid-cols-2 gap-4 text-left" data-id="element-231">
            <div className="flex items-center gap-3" data-id="element-232">
              <span className="text-brand" data-id="element-233">✅</span> Protocolos listos para
              aplicar desde el día 1
            </div>
            <div className="flex items-center gap-3" data-id="element-234">
              <span className="text-brand" data-id="element-235">✅</span> Material para entregar al
              paciente
            </div>
            <div className="flex items-center gap-3" data-id="element-236">
              <span className="text-brand" data-id="element-237">✅</span> Basado en evidencia ·
              Adaptado a Argentina
            </div>
            <div className="flex items-center gap-3" data-id="element-238">
              <span className="text-brand" data-id="element-239">✅</span> 100% listo para usar — sin
              buscar, sin armar
            </div>
          </div>
        </div>
      </div>
    </section>;
}